export type HistoryRange = 'week' | 'all';
export type HistoryPlayedAt = Record<string, number>;
const WEEK_MS = 7 * 24 * 60 * 60 * 1000;
const validTime = (value: unknown): value is number => typeof value === 'number' && Number.isSafeInteger(value) && value > 0 && value <= 8_640_000_000_000_000;

/** Legacy history contains IDs only; never substitute a track's added/updated time. */
export function normalizeHistoryPlayedAt(value: unknown, history: readonly string[]): HistoryPlayedAt {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
  const record = value as Record<string, unknown>;
  return Object.fromEntries(history.filter(id => Object.hasOwn(record, id) && validTime(record[id])).map(id => [id, record[id] as number]));
}

/** Call only once audio actually starts playing, including a later replay/resume. */
export function recordHistoryPlayback(history: readonly string[], playedAt: HistoryPlayedAt, id: string, now = Date.now()) {
  if (!id || !validTime(now)) return { history: [...history], historyPlayedAt: normalizeHistoryPlayedAt(playedAt, history) };
  const next = [id, ...history.filter(item => item !== id)].slice(0, 50);
  return { history: next, historyPlayedAt: { ...normalizeHistoryPlayedAt(playedAt, next), [id]: now } };
}

export function historyTrackIds(history: readonly string[], playedAt: HistoryPlayedAt, range: HistoryRange, now = Date.now()): string[] {
  if (range === 'all') return [...history];
  return history.filter(id => Object.hasOwn(playedAt, id) && validTime(playedAt[id]) && playedAt[id] >= now - WEEK_MS && playedAt[id] <= now);
}
